import { FormEvent, ReactNode, useState } from 'react';
import { ButtonType } from '../scripts/constants/enums';

const STATUS = {
  HOVERED: 'hovered',
  NORMAL: 'normal',
};

interface Props {
  text: string;
  type?: ButtonType;
  disabled?: boolean;
  class?: string;
  children?: ReactNode;
  onClick?: (e: FormEvent) => void;
}

export default function Button({ ...props }: Props) {
  const [status, setStatus] = useState(STATUS.NORMAL);

  const onMouseEnter = () => {
    setStatus(STATUS.HOVERED);
  };

  const onMouseLeave = () => {
    setStatus(STATUS.NORMAL);
  };

  return (
    <button
      className={`${status} ${props.class}`}
      type={props.type || ButtonType.button}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.text}
      {props.children}
    </button>
  );
}
